var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "component_labels" },
    _vm._l(_vm.labelList, function(item, index) {
      return item && item.length > 0 && item !== "[]" && item !== "0"
        ? _c(
            "div",
            { staticClass: "component_label", attrs: { title: item } },
            [_vm._v("\n    " + _vm._s(item) + "\n  ")]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }